const VALIDATION_MESSAGES = {
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
  };
};

export default useValidation;
